import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { api, fileUrl, formatINR } from "../lib/api";
import MyPageShell, { EmptyState } from "../components/MyPageShell";

export default function SavedProperties() {
    const [items, setItems] = useState(null);
    useEffect(() => {
        api.get("/saved").then((r) => setItems(r.data || [])).catch(() => setItems([]));
    }, []);

    return (
        <MyPageShell title="Saved Properties" subtitle="Your handpicked wishlist — pick up right where you left off." testid="saved-properties-page">
            <div className="text-xs text-navy-500/60 mb-3">
                {items === null ? "Loading…" : `${items.length} saved`}
            </div>
            {items === null && <div className="py-12 text-center text-sm text-navy-500/50">Loading your saved properties…</div>}
            {items && items.length === 0 && (
                <EmptyState
                    icon={Heart}
                    title="Your wishlist is empty"
                    message="Tap the heart on any property to save it here for later."
                    cta="Browse properties"
                    to="/properties"
                    testid="saved-empty"
                />
            )}
            {items && items.length > 0 && (
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {items.map((p) => (
                        <li key={p.id} data-testid={`saved-item-${p.id}`}>
                            <Link to={`/properties/${p.id}`} className="block rounded-xl border border-navy-500/10 bg-white overflow-hidden hover:border-gold-500/40 transition-colors">
                                <div className="aspect-[16/10] bg-navy-500/8">
                                    {p.images?.[0] && <img src={fileUrl(p.images[0])} alt={p.title} className="w-full h-full object-cover" />}
                                </div>
                                <div className="p-3">
                                    <div className="font-heading font-bold text-navy-500 text-sm truncate">{p.title}</div>
                                    <div className="text-[11px] text-navy-500/55 truncate">{p.locality ? `${p.locality}, ` : ""}{p.city}</div>
                                    <div className="mt-1 text-gold-700 font-bold text-sm">{formatINR(p.price)}</div>
                                </div>
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </MyPageShell>
    );
}
